import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=90ed5194&scoped=true&"
import script from "./Exhibition.vue?vue&type=script&lang=ts&"
export * from "./Exhibition.vue?vue&type=script&lang=ts&"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=90ed5194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ed5194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VTab,VTabItem,VTabs,VTabsItems})
